import { AuthenticationTicket } from '../../backend/model';

export class BankIdAutoStartUtil {
  private static readonly BASE_URL = 'bankid://';
  private static readonly AUTOSTARTTOKEN = 'autostarttoken';

  public static autoStart(authenticationTicket: AuthenticationTicket): void {
    let params = '';

    if (authenticationTicket?.autoStartToken != null) {
      params += this.addParam(params, this.AUTOSTARTTOKEN, authenticationTicket.autoStartToken);
    }

    window.location.href = this.BASE_URL + params;
  }

  private static addParam(currentParams: string, paramName: string, paramValue: string): string {
    return this.addParameterSymbol(currentParams) + paramName + '=' + paramValue;
  }

  private static addParameterSymbol(currentParams: string): string {
    if (currentParams && currentParams.length) {
      return '&';
    }

    return '?';
  }
}
